import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import SubTabsPage from '@customer/templates/sub-tabs-page/SubTabsPage';
import { Outlet } from 'react-router-dom';
import NavTabs from '@cas/components/tabs/nav-tabs/NavTabs';
import { NavTabModel } from '@cas/components/tabs/nav-tab/NavTab';

export function Configuration() {
  const { t } = useTranslation();

  const tabs = useMemo<NavTabModel[]>(
    () => [
      {
        title: t('SoftwareStatus'),
        to: `/health/configuration/software-status`,
      },
      {
        title: t('AssetNameMismatch'),
        to: `/health/configuration/asset-name-mismatch`,
      },
    ],
    [t],
  );

  return (
    <SubTabsPage tabs={<NavTabs tabs={tabs} />}>
      <Outlet />
    </SubTabsPage>
  );
}

export default Configuration;
